/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query LegalQuery($uid: String!) {
    prismic {
      legal(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_LegalBodyDocumentcontent {
          type
            label
            fields {
              breadcrumb_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              breadcrumb_active
              breadcrumb_text
            }
            primary {
              text_color
              background_color
              background_image
              heading
              heading_color
              subheading
              subheading_color
              document_content_text
              modal_link_title
              modal_link_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
                 ... on PRISMIC__FileLink {
                  _linkType
                  url
                }
              }
              modal_ref_title
              modal_ref_copy
              modal_primary_button_text
              modal_secondary_button_text
              section_id
            }
        },
        ... on PRISMIC_LegalBodyTable {
          
type
label
primary {
  background_color
  heading
  subheading
  text_color
  column_header_1
  column_header_2
  column_header_3
  column_header_4
  column_header_5
  column_header_6
}
fields {
  column_1
  column_2
  column_3
  column_4
  column_5
  column_6
}
        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const Legal = ({ data, location }) =>
  data.prismic.legal ? (
    <MainLayout location={location} layout='legal'>
    <Helmet>
      <title>{(data.prismic.legal.title[0] && data.prismic.legal.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.legal.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.legal.path : 'https://www.digitalocean.com' + data.prismic.legal.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.legal.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.legal.title[0] ? data.prismic.legal.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.legal.description ? data.prismic.legal.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.legal.open_graph_image ? data.prismic.legal.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.legal.description ? data.prismic.legal.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.legal.title[0] ? data.prismic.legal.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.legal.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.legal.path : 'https://www.digitalocean.com' + data.prismic.legal.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.legal.open_graph_image ? data.prismic.legal.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      <SliceZone allSlices={data.prismic.legal.body} />
    </MainLayout>
  ) : null;

Legal.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Legal;
